import './logo.scss';

function Logo() {
  return (
    <div className='logo'>
      <span role='img'>🍿</span>
      <div className='logo__title'>
        <h1>usePopcorn</h1>
      </div>
    </div>
  );
}

export default Logo;
